import _defaultTo from 'lodash/defaultTo';
import { fromJS } from 'immutable';

import workastDataUtils from './utils';
import workastDataConstants from './constants';

const initialState = fromJS({
  token: null,
  listId: null,
  teamName: null,
  organizationName: null,
  userName: null
});

const workastDataReducer = (state, action) => {
  const safeState = _defaultTo(state, initialState);

  const {
    type,
    payload
  } = action;

  switch (type) {
    case workastDataConstants.SET_INITIAL_DATA:
      return workastDataUtils.setInitialData(state, payload);

    default:
      return safeState;
  }
};

export default workastDataReducer;
